import * as ko from 'knockout'
import template from './race.finisher.tpl.html'
import { Params, RaceFinisherViewModel } from './RaceFinisherViewModel'

if (!ko.components.isRegistered('race-finisher')) {
  ko.components.register('race-finisher', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new RaceFinisherViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
